<template>
    <div class="list-turma">

        <c-panel>

            <el-form label-position="top" class="u-mb-30">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="15" :md="17" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                        <el-form-item key="instituicao">
                            <el-select @change="changeFiltros" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item key="periodo">
                            <el-select @change="changeFiltros" v-model="filtro.periodo.id">
                                <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="$store.state.user.tipo == 6" :xs="24" :sm="5" :md="3" class="u-text-right">
                        <el-button type="primary" @click="showDialogFormTurma(null)">NOVA TURMA</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="table-turmas container-table" v-if="statusList && Object.keys(items).length > 0">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="hidden-mobile u-text-center"><b>TURNO</b></th>
                            <th style="width: 110px;" class="hidden-mobile u-text-center"><b>VAGAS INICIAIS</b></th>
                            <th style="width: 110px;" class="hidden-mobile u-text-center"><b>MATRÍCULADOS</b></th>
                            <th v-if="$store.state.config.parametros.fase_matricula == 1 ||
                                      $store.state.config.parametros.fase_matricula == 2 ||
                                      $store.state.config.parametros.fase_matricula == 3"
                                style="width: 110px;" class="hidden-mobile u-text-center"><b>AGENDADOS</b></th>
                                <th style="width: 110px;" class="hidden-mobile u-text-center"><b>VAGAS REAIS</b></th>
                            <th style="width: 260px;" class="hidden-mobile u-text-center"><b>AÇÕES</b></th>
                        </tr>
                    </thead>
                    <tbody>

                        <template v-for="(cursos, m) in items">

                            <tr :key="m">
                                <td class="titleTurma" colspan="100%">{{ m }}</td>
                            </tr>

                            <template v-for="(turmas, i) in cursos">
                                <tr :key="turmas.id">
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}"><span style="margin-left: 30px;"><b>TURMA:</b> {{ turmas.nome }}</span></td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">{{ $CONSTANTS.TURNO[turmas.turno] }}</td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">{{ turmas.qtd_vagas }}</td>
                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">{{ turmas.qtd_matriculados }}</td>

                                    <td v-if="$store.state.config.parametros.fase_matricula == 1 ||
                                              $store.state.config.parametros.fase_matricula == 2 ||
                                              $store.state.config.parametros.fase_matricula == 3"
                                        v-bind:style="{borderTop: (i == 0) ? 'none' : ''}"
                                        class="hidden-mobile u-text-center">{{ turmas.qtd_agendados }}</td>

                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-center">
                                        {{ ((turmas.qtd_vagas - (turmas.qtd_matriculados + turmas.qtd_agendados) > 0) ? turmas.qtd_vagas - (turmas.qtd_matriculados + turmas.qtd_agendados) : 0 ) }}
                                    </td>

                                    <td v-bind:style="{borderTop: (i == 0) ? 'none' : ''}" class="hidden-mobile u-text-right" style="padding-right: 0;">

                                        <el-button v-if="[0, 1, 3, 4, 5, 6, 7, 12].includes(Number($store.state.user.tipo)) && turmas.qtd_horarios > 1 && turmas.tipo_ensino != 3" @click="showDialogHorarios(turmas.id, (`${m} - ${turmas.nome}`), turmas.qtd_horarios)" title="Horários de aulas" size="mini">
                                            <i class="far fa-calendar-alt"></i>
                                        </el-button>

                                        <el-button @click="printAtestadoTransferenciaEmLote(turmas.id)" v-if="$store.state.user.tipo < 7 && (turmas['curso_id'] == 1185 || turmas['curso_id'] == 1177 || turmas['curso_id'] == 1193 || turmas['concluinte']) && filtro.periodo.id == $store.state.config.periodo.periodo_anterior_id" type="info" title="Imprimir Atestados de Transferência em Lote" size="mini">
                                            <i class="fas fa-file-pdf"></i>
                                        </el-button>

                                        <el-button @click="setConcluinte(turmas.id)" v-if="$store.state.user.tipo == 6 && !turmas['concluinte'] && filtro.periodo.id == $store.state.config.periodo.periodo_anterior_id" type="danger" title="Marcar turma como Conluinte" size="mini">
                                            <i class="fas fa-arrow-alt-circle-right"></i>
                                        </el-button>

                                        <el-button @click="revertConcluinte(turmas.id)" v-if="$store.state.user.tipo == 6 && turmas['concluinte'] && filtro.periodo.id == $store.state.config.periodo.periodo_anterior_id" type="success" title="Reverter Concluinte" size="mini">
                                            <i class="fas fa-arrow-alt-circle-left"></i>
                                        </el-button>

                                        <el-button @click="setDataTransferencia(turmas.id)" v-if="[0, 1, 4, 5, 6].includes(Number($store.state.user.tipo)) && turmas['concluinte'] && filtro.periodo.id == $store.state.config.periodo.periodo_anterior_id && (turmas['fase_diario'] == 5) " type="info" title="Setar Data de Transferência" size="mini">
                                            <i class="fas fa-calendar-alt"></i>
                                        </el-button>

                                        <el-button @click="printStudentsOfClass(turmas.id)" type="warning" title="Gerar Relatório da Turma" size="mini">
                                            <i class="fas fa-print"></i>
                                        </el-button>

                                        <el-button v-if="[0, 1, 4, 5, 6, 7].includes(Number($store.state.user.tipo))" @click="showDialogFormTurma(turmas.id)" type="info" title="Editar" icon="el-icon-edit" size="mini"></el-button>

                                        <router-link :to="'/admin/turma/info/'+ turmas.id" style="margin-left: 10px;">
                                            <el-button type="primary" title="Visualizar detalhes" icon="el-icon-search" size="mini"></el-button>
                                        </router-link>

                                        <!-- <el-button style="margin-left: 10px;" v-if="$store.state.user.tipo != 10 && $store.state.user.tipo == 6" @click="deleteTurma(turmas.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini"></el-button> -->

                                    </td>
                                </tr>
                            </template>

                        </template>

                    </tbody>
                </table>
            </div>

            <div v-if="!statusList" class="u-text-center" style="margin-top: 50px; margin-bottom: 50px;">
                <hr>
                    <img class="u-mt-10 u-mb-10" src="/public/img/loading-bar.gif" />
                <hr>
            </div>

            <div v-if="statusList && filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">nenhuma turma cadastrada</h4>
            </div>

            <div v-if="statusList && !filtro.instituicao.id && Object.keys(items).length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">selecione uma instituição</h4>
            </div>

        </c-panel>

        <el-dialog :close-on-click-modal="false" title="NOVA TURMA" width="70%" top="5vh" :visible.sync="dialogFormTurma">
            <form-turma
                v-if="dialogFormTurma"
                :paramId="turmaSelected ? turmaSelected.id : null"
                v-on:onSubmitTurma="onSubmitTurma"
                v-on:close="closeDialogTurmas"
                :instituicao="filtro.instituicao.id"
                :periodo_letivo="filtro.periodo.id"
            ></form-turma>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :title="`HORÁRIOS DE AULA - ${turmaSelected ? turmaSelected.nome : ''}`" width="70%" :visible.sync="dialogHorarios">
            <form-horarios
                v-if="dialogHorarios"
                :paramId="turmaSelected"
                v-on:onSubmitHorarios="onSubmitHorarios"
                v-on:close="closeDialogHorarios()"
                :instituicao="filtro.instituicao.id"
                :periodo_letivo="filtro.periodo.id"
            ></form-horarios>
        </el-dialog>

    </div>
</template>
<script>

import formTurma from '@/components/turma/form/form'
import formHorarios from '@/components/turma/horarios/horarios'

export default {
    data: () => ({
        turmaSelected: {},
        dialogFormTurma: false,
        dialogHorarios: false,
        loadingInstituicao: false,
        statusList: true,
        filtro: {
            instituicao: {
                id: '',
                nome: ''
            },
            periodo: {
                id: '',
                nome: ''
            },
        },
        items: {},
        selectPeriodos: [],
        selectInstituicoes: []

    }),
    mounted(){

        this.filtro.periodo = {... this.$store.state.config.periodo};

        if(this.$store.state.config.instituicao){

            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadingTurmas();
    },
    methods: {
        setDataTransferencia(id){

            this.$msgbox.confirm('Informar da data de transferêcia dos Alunos desta turma?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/setDataTransferencia/${id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingTurmas();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        printAtestadoTransferenciaEmLote(id){

            window.eventBus.$emit('print', {url: '/api/pdf/renderAtestadoTransferenciaEmLote', param: {turma_id: id }});
        },
        setConcluinte(id){

            this.$msgbox.confirm('Tem certeza que deseja setar esta turma como conluinte?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/setConcluintes/${id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingTurmas();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        revertConcluinte(id){

            this.$msgbox.confirm('Tem certeza que deseja reverter a situação de concluinte desta turma?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/revertConcluintes/${id}`, this.$store.getters.getHeaderAuth).then(response => {

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingTurmas();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        },
        printStudentsOfClass(id){

            window.eventBus.$emit('print', {url: '/api/pdf/renderStudentsOfClass', param: {turma_id: id }});
        },

        showDialogFormTurma(id){

            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id || !this.filtro.periodo.id){

                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição e um período letivo.', type: 'warning'});
                return false;
            }

            if(id){

                this.turmaSelected = { id };

            }else{

                this.turmaSelected = null;
            }

            this.dialogFormTurma = true

        },
        
        closeDialogTurmas(){
            
            this.dialogFormTurma = false;
        },

        showDialogHorarios(id, nome, qtd_horarios){
            
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id || !this.filtro.periodo.id){

                window.eventBus.$emit('alert', {msg: 'Por favor, selecione uma instituição e um período letivo.', type: 'warning'});
                return false;
            }

            this.turmaSelected = { id, nome, qtd_horarios };

            this.dialogHorarios = true

        },

        closeDialogHorarios(){
            
            this.dialogHorarios = false;
        },

        async changeFiltros(){

            if(this.$store.state.user.tipo > 3 && this.$store.state.user.tipo <= 8){

                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }

            this.loadingTurmas();
        },
        loadingTurmas(){


            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id || !this.filtro.periodo.id){

                return false;
            }

            let i = this.$store.state.config.instituicao.id;
            let p = this.filtro.periodo.id;

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListTurmas/` + i + '/' + p, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitTurma(){

            this.dialogFormTurma = false;
            this.loadingTurmas();
        },
        onSubmitHorarios(){

            this.dialogHorarios = false;
        },
        deleteTurma(id){

            this.$msgbox.confirm('Só é permitido excluir uma turma, se não existirem vinculos com a mesma. Tem certeza que deseja continuar?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);

                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/turma/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {

                    if(typeof response.data.throw !== 'undefined'){

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: response.data.throw.msg, type: response.data.throw.type});

                    }else{

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        this.loadingTurmas();
                    }



                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});
        }
    },
    components:{ formTurma, formHorarios }
}
</script>
<style>

    .table-turmas .table th, .table-turmas .table td {
        padding: 5px 10px;
    }

    .list-turma .list-turno{
        padding-left: 0px;
    }

    .titulo-curso{

        background-color: #e8e8e8;
        margin-top: 25px;
        padding: 5px 20px;
        display: block;
    }

    .list-cursos{
        padding-left: 15px;
    }

    .list-turmas{

        margin-top: 10px;
        display: block;
    }

    .instituicao .container-list-turmas{
        text-transform: uppercase;
    }

    .row-turma{
        border-bottom: 1px solid #ccc;
    }


</style>